import React from 'react';
import { X, Lightbulb } from 'lucide-react';
import { useOnboarding } from './OnboardingContext';

/**
 * Subtle inline banner for onboarding guidance.
 * Use when there's no single element to attach a hint to.
 */
export const OnboardingBanner = ({ id, children }) => {
  const { isHintDismissed, dismissHint } = useOnboarding();

  if (isHintDismissed(id)) {
    return null;
  }

  return (
    <div
      className="animate-fade-in flex items-start gap-3 rounded-2xl border border-[#e8e2d8] bg-[#fffcf7]/95 p-4 shadow-sm"
      data-testid={`banner-${id}`}
    >
      <Lightbulb className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#c9a961]" aria-hidden />
      <p className="flex-1 text-sm leading-relaxed text-[#4a433c]">{children}</p>
      <button
        type="button"
        onClick={() => dismissHint(id)}
        className="flex-shrink-0 text-[#8b7355] transition-colors hover:text-[#1c1917]"
        data-testid={`banner-dismiss-${id}`}
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default OnboardingBanner;
